import React from "react";
import {
  StyledProductLeadBlockTitle,
  StyledProductLeadTabIFrame
} from "../../../components/styles/ProductLeadBlock.styles";
import RichText, { type RichTextData } from "../../../components/RichText";

const SpecificationIframe = ({
  specificationIframeUrl,
  pdpSpecificationTitle,
  pdpSpecificationDescription
}: {
  specificationIframeUrl: string;
  pdpSpecificationTitle?: string | null;
  pdpSpecificationDescription?: RichTextData | null;
}) => {
  return (
    <>
      {pdpSpecificationTitle && (
        <StyledProductLeadBlockTitle
          variant="h5"
          data-testid="specification-title"
        >
          {pdpSpecificationTitle}
        </StyledProductLeadBlockTitle>
      )}
      {pdpSpecificationDescription && (
        <RichText
          document={pdpSpecificationDescription}
          data-testid="specification-description"
        />
      )}
      <StyledProductLeadTabIFrame
        url={specificationIframeUrl}
        data-testid="specification-iframe"
        title={
          pdpSpecificationTitle
            ? `${pdpSpecificationTitle} iFrame`
            : "Specification iFrame"
        }
      />
    </>
  );
};

export default SpecificationIframe;
